import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux';
import { makeStyles, MenuItem, Select } from '@material-ui/core';
import "./styles.scss";
import { Box, Button, IconButton, Tooltip, Typography } from '@mui/material';
import { Close } from '@material-ui/icons';
import outputSound from '../../../assets/media/outputTest.mp3';
import _ from 'lodash';
import { setInputDevice, setOutputDevice, soundSettings } from '../../../redux/actions/settings';

const useStyles = makeStyles((theme) => ({
    icons:{
      width: 25,
      height: 25
    }
  }));

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    borderRadius: 3,
    outline: 'none',
    boxShadow: 24,
};

const closeButton = {
    largeIcon: {
        width: 30,
        height: 30,
        position: 'absolute',
        top: '17px',
        right: '17px',
    },
};

const selectedText = {
    fontSize: '12px',
    fontStyle: 'oblique',
    fontWeight: 500,
    // maxWidth: 425,
    textShadow: '0.3px 0.3px dodgerblue',
}

let constraints = {};
let oldArraySum = 0;
function InputDeviceSetting(props) {
    const classes = useStyles();
    const [audioInput, setAudioInput] = useState([]);
    const [selectedAudioInput, SetSelectedAudioInput] = useState('');
    const [audioOutput, setAudioOutput] = useState([]);
    const [selectedAudioOutput, SetSelectedAudioOutput] = useState('');

    let { soundDevices, dispatch } = props;

    useEffect(() => {
        getDevices();
    }, [])

    useEffect(() => {
        if (selectedAudioInput) {
            constraints = {
                audio: { deviceId: { exact: selectedAudioInput } },
                video: false
            };
            dispatch(setInputDevice(selectedAudioInput));
            handleAudioMic();
        }
    }, [selectedAudioInput])

    useEffect(() => {
        if (selectedAudioOutput) {
            dispatch(setOutputDevice(selectedAudioOutput));
            changeAudioDestination();
        }
    }, [selectedAudioOutput])


    const getDevices = () => {
        const Media = navigator.mediaDevices;
        var audioInputArr = [];
        var audioOutputArr = [];

        Media.enumerateDevices()
            .then(function (devices) {
                devices.forEach(function (device) {
                    if (device.kind === 'audioinput') {
                        audioInputArr.push({
                            value: device.deviceId,
                            text: device.label
                        })
                    }

                    if (device.kind === 'audiooutput') {
                        audioOutputArr.push({
                            value: device.deviceId,
                            text: device.label
                        })
                    }
                });
                setAudioInput(audioInputArr);
                let inputNotFound = true;
                let outputNotFound = true;
                audioInputArr.forEach(({ value }) => {
                    if (value === soundDevices.input) {
                        inputNotFound = false;
                    }
                });
                audioOutputArr.forEach(({ value }) => {
                    if (value === soundDevices.output) {
                        outputNotFound = false;
                    }
                });
                (!(soundDevices && soundDevices.input) || inputNotFound) && SetSelectedAudioInput(audioInputArr[0].value);
                setAudioOutput(audioOutputArr);
                (!(soundDevices && soundDevices.output) || outputNotFound) && SetSelectedAudioOutput(audioOutputArr[0].value);
            })
    }

    const colorPids = (vol) => {
        const allPids = [...document.querySelectorAll('.pid')];
        const numberOfPidsToColor = Math.round(vol / 1.25);
        const pidsToColor = allPids.slice(0, numberOfPidsToColor);
        for (const pid of allPids) {
            pid.style.backgroundColor = "#e6e7e8";
        }

        for (let i = 0; i < pidsToColor.length; i++) {
            if (i < 1) {
                pidsToColor[i].style.backgroundColor = "#efb06c";
            } else {
                pidsToColor[i].style.backgroundColor = "#69ce2b";
            }
        }
    }

    const handleCloseMicPanel = () => {
        dispatch(soundSettings(false));
    }

    const handleChangeAudioInput = (e) => {
        console.log('dropdown value ', e.target);
        SetSelectedAudioInput(e.target.value);
    }

    const handleChangeAudioOutput = (e) => {
        console.log('dropdown value ', e.target);
        SetSelectedAudioOutput(e.target.value);
    }

    const handleAudioMic = () => {
        if (_.isEmpty(constraints)) {
            constraints = { audio: true, video: false };
        }

        if (window.stream) {
            window.stream.getTracks().forEach(track => {
                track.stop();
            });
        }

        navigator.mediaDevices.getUserMedia(constraints)
            .then(function (stream) {
                window.stream = stream;
                const audioContext = new AudioContext();
                const analyser = audioContext.createAnalyser();
                const microphone = audioContext.createMediaStreamSource(stream);
                const scriptProcessor = audioContext.createScriptProcessor(2048, 1, 1);

                // analyser.smoothingTimeConstant = 0.2;
                analyser.fftSize = 1024;

                microphone.connect(analyser);
                analyser.connect(scriptProcessor);
                scriptProcessor.connect(audioContext.destination);
                scriptProcessor.onaudioprocess = function () {
                    const array = new Uint8Array(analyser.frequencyBinCount);
                    analyser.getByteFrequencyData(array);
                    let arraySum = array.reduce((a, value) => a + value, 0);
                    arraySum = (arraySum == 0 && oldArraySum > 0) ? oldArraySum : arraySum;
                    oldArraySum = arraySum;
                    const average = arraySum / array.length;
                    // console.log(" average", arraySum, array.length,  average)
                    colorPids(average);
                };
            })
            .catch(function (err) {
                /* handle the error */
                console.error(err);
            });

    }

    navigator.mediaDevices && (navigator.mediaDevices.ondevicechange = function () {
        getDevices();
    })

    const attachSinkId = (element, sinkId) => {
        if (typeof element.sinkId !== 'undefined') {
            element.setSinkId(sinkId)
                .then(() => {
                    console.log(`Success, audio output device attached: ${sinkId}`);
                })
                .catch(error => {
                    let errorMessage = error;
                    if (error.name === 'SecurityError') {
                        errorMessage = `You need to use HTTPS for selecting audio output device: ${error}`;
                    }
                    console.error(errorMessage);
                    // Jump back to first output device in the list as it's the default.
                    SetSelectedAudioOutput(audioOutput[0].value);
                });
        } else {
            console.warn('Browser does not support output device selection.');
        }
    }

    const changeAudioDestination = () => {
        const audioElement = document.getElementById('audio');
        attachSinkId(audioElement, selectedAudioOutput);
    }

    const handleStartAudio = () => {
        const audioElement = document.getElementById("audio");
        audioElement.play();
    }

    return (
        <Box sx={!props?.noModal && style} className={props?.noModal ? 'mic_settings_noModal' : 'mic_settings_modal'}>
            <Typography id="modal-title" variant="h5" className='title' component="div" mb={2} mr={2}>
                Sound Settings
            </Typography>

            {!props?.noModal &&
                <IconButton
                    variant="contained"
                    onClick={handleCloseMicPanel}
                    style={closeButton.largeIcon}
                    className='closeBtnIcon'
                >
                    <Tooltip title="Close" className="settings_close_tooltip">
                        <Close className="settings_close_icon" />
                    </Tooltip>
                </IconButton>
            }

            <div className='spectrum_wrapper'>
                <div className='spectrum'>
                    <label className='spectrum_label'>Input Devices</label>
                    <div className='spectrum_item'>
                        <Select
                            id="demo-simple-select"
                            value={soundDevices.input}
                            defaultValue={soundDevices.input}
                            onChange={handleChangeAudioInput}
                            className='selectedText'
                            classes={{icon: classes.icons}}
                            displayEmpty={true}
                        >
                            {
                                audioInput && audioInput.map((item, i) => {
                                    return (
                                        <MenuItem
                                            key={i}
                                            value={item.value}
                                            style={selectedText}
                                        >{item.text}</MenuItem>
                                    )
                                })
                            }
                        </Select>
                    </div>
                </div>

                <div className='spectrum'>
                    <label className='spectrum_label'>Input Level</label>
                    <div className="pids-wrapper">
                        {[...Array(10)].map((x, i) =>
                            <div key={i} className="pid"></div>
                        )}
                    </div>
                </div>

                <div className='spectrum'>
                    <label className='spectrum_label'>Output Devices</label>
                    <div className='spectrum_item'>
                        <Select
                            id="demo-simple-select"
                            value={soundDevices.output}
                            defaultValue={soundDevices.output}
                            onChange={handleChangeAudioOutput}
                            className='selectedText'
                            classes={{icon: classes.icons}}
                            displayEmpty={true}
                        >
                            {
                                audioOutput && audioOutput.map((item, i) => {
                                    return (
                                        <MenuItem
                                            key={i}
                                            value={item.value}
                                            style={selectedText}
                                        >{item.text}</MenuItem>
                                    )
                                })
                            }
                        </Select>
                    </div>
                </div>

                <div className='spectrum'>
                    <audio id='audio' src={outputSound} width="300" height="30" />
                    <div className='test_output_btn'>
                        <Button
                            variant="contained"
                            color="success"
                            onClick={handleStartAudio}
                        >Test Output</Button>
                    </div>
                </div>
            </div>
        </Box>
    )
}

const mapState = ({ platform: { settings: { soundDevices } } }) => {
    return {
        soundDevices
    }
};

export default connect(mapState)(InputDeviceSetting);
